import React from 'react'

const Hgray = (props) => {
  return (
    <div className=' text-[20px] pb-2 text-gray-400 '>{props.data}</div>
  )
}

export default Hgray